import React, { useEffect, useState } from 'react';
import { Button, Popover, Tabs } from 'antd';
import { ServerAPI } from '../../common/ServerAPI';
import { json } from 'react-router-dom';
import { IMAGE_BASE_URL } from '../../common/Constants';
import SamplePreviewContainer from './SamplePreviewContainer';
import {
  downloadLoanApplicationProductForms,
  downloadLoanApplicationProductFormsZip,
} from '../../common/Utilities';
import { FileZipOutlined, DownloadOutlined } from '@ant-design/icons';

const ApplicationPreview = ({ holderId, view }) => {
  const [loanDetails, setLoanDetails] = useState([]);
  const [downloadPopOver, setDownloadPopOver] = useState(false);
  const { TabPane } = Tabs;
  const ApplicationId = localStorage.getItem('applicationId');

  const handleOpenChange = (newOpen) => {
    setDownloadPopOver(newOpen);
  };

  const getLoanDetails = async () => {
    const response = await ServerAPI.getApplicationWithoutToken();
    if (response) {
      if (response.data) {
        let bank_values = response.data['products']['Bank'];
        let financial_institution_values =
          response.data['products']['Financial_Institution'];
        let inhouse_values = response.data['products']['In-House'];
        const combinedArray = bank_values.concat(
          financial_institution_values,
          inhouse_values
        );
        setLoanDetails(combinedArray);
      }
    }
  };

  useEffect(() => {
    getLoanDetails();
  }, []);

 // console.log('loanDetails', ApplicationId);
  return (
    <div className='pl-1'>
      <Tabs centered defaultActiveKey='1'>
        {loanDetails != undefined &&
          loanDetails.length > 0 &&
          loanDetails.map((loan, idx) => {
            return (
              <TabPane
                tab={
                  <div className='flex flex-wrap'>
                    <img
                      className='w-[30px] h-[30px] rounded-full mr-2'
                      src={IMAGE_BASE_URL + '/' + loan.icon}
                    />
                    <p className='mt-1 flex gap-1'>
                      <span className='text-ellipsis overflow-hidden max-w-[92px]'>
                        {loan.name}
                      </span>
                      <span> - {loan.int_rate}%</span>
                    </p>
                  </div>
                }
                key={idx + 1}
              >
                {ApplicationId !== null && ApplicationId !== undefined && (
                  <div className='flex justify-end'>
                    <Popover
                      content={
                        <div>
                          <Button
                            type='primary'
                            onClick={() => {
                              downloadLoanApplicationProductFormsZip(
                                ApplicationId
                              );
                            }}
                            className='min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2'
                          >
                            <FileZipOutlined className='mr-2 mt-1' />
                            <p>Download Zip</p>
                          </Button>
                          <Button
                            type='primary'
                            onClick={() => {
                              downloadLoanApplicationProductForms(
                                ApplicationId
                              );
                            }}
                            className='min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px]'
                          >
                            <DownloadOutlined className='mr-2 mt-1' />
                            <p>Download Files</p>
                          </Button>
                        </div>
                      }
                      placement='bottom'
                      trigger='click'
                      open={downloadPopOver}
                      onOpenChange={handleOpenChange}
                    >
                      <div className='w-fit'>
                        <Button
                          className='min-[768px]:text-[14px] max-[768px]:text-[12px] mb-3'
                          type='primary'
                        >
                          Download All Documents
                        </Button>
                      </div>
                    </Popover>
                  </div>
                )}
                <SamplePreviewContainer
                  productId={loan?.application_product}
                  holderId={holderId}
                  view={view}
                />
              </TabPane>
            );
          })}
      </Tabs>
    </div>
  );
};

export default ApplicationPreview;
